import React, { useState } from "react";
import { Descriptions, Drawer } from "antd";
import moment from "moment";
import { cashConverter } from "../../../../utils";

function AboutProject({ open, onClose, project }) {
  const [more, setMore] = useState(false);

  const DescriptionPanel = ({ text }) => {
    const [expanded, setExpanded] = useState(false);
    const maxHeight = "4.5rem";

    return (
      <div>
        <div
          style={{
            maxHeight: expanded ? "none" : maxHeight,
            overflow: "hidden",
            position: "relative",
            whiteSpace: "pre-wrap",
          }}
        >
          {text || "N/A"}
        </div>
        {text?.length > 120 && (
          <div className="mt-1">
            <button
              onClick={() => setExpanded(!expanded)}
              className="py-1 cursor-pointer text-darkBlue font-interSans text-[.875rem] font-[500] underline gap-x-[.5rem] flex items-center"
            >
              <span className="flex items-center gap-1 text-darkBlue font-interSans text-[.875rem] font-[500] hover:underline">
                {expanded ? "View Less" : "View More"}
              </span>
            </button>
          </div>
        )}
      </div>
    );
  };

  const items1 = [
    { key: "1", label: "Project Number", children: project?.projectNumber ?? "N/A" },
    { key: "2", label: "Project Name", children: project?.projectName ?? "N/A" },
    { key: "3", label: "Project Scope", children: <DescriptionPanel text={project?.projectScope} /> },
    { key: "4", label: "Project Purpose", children: <DescriptionPanel text={project?.projectPurpose} /> },
    { key: "5", label: "Status", children: project?.projectStatus ?? "N/A" },
    { key: "6", label: "Pathway", children: project?.projectPathwayName ?? "N/A" },
    { key: "7", label: "Program", children: project?.projectProgramName ?? "N/A" },
    { key: "8", label: "Project Type", children: project?.projectTypeName ?? "N/A" },
    { key: "9", label: "Threshold", children: project?.projectThresholdName ?? "N/A" },
    { key: "10", label: "Engineer in Charge", children: project?.projectEngineerName ?? "N/A" },
    { key: "11", label: "Implementing Entity", children: project?.projectAgencyName ?? "N/A" },
    { key: "12", label: "Contractor", children: project?.projectContractor ?? "N/A" },
    { key: "13", label: "County", children: project?.projectCountyName ?? "N/A" },
    { key: "14", label: "Subcounty", children: project?.projectSubCountyName ?? "N/A" },
    { key: "15", label: "Location", children: project?.projectLocationName ?? "N/A" },
    { key: "16", label: "Latitude", children: project?.projectLatitude ?? "N/A" },
    { key: "17", label: "Longitude", children: project?.projectLongitude ?? "N/A" },
  ];

  const items2 = [
    {
      key: "1", label: "Commencement Date",
      children: project?.projectStartDate ? moment(project?.projectStartDate)?.format("DD-MM-YYYY") : "--",
    },
    {
      key: "2", label: "Expected End Date",
      children: project?.projectEndDate ? moment(project?.projectEndDate)?.format("DD-MM-YYYY") : "--",
    },
    {
      key: "3", label: "Revised End Date",
      children: project?.projectRevisedEndDate ? moment(project?.projectRevisedEndDate)?.format("DD-MM-YYYY") : "--",
    },
    {
      key: "4", label: "Award Date",
      children: project?.projectContractAwardDate ? moment(project?.projectContractAwardDate)?.format("DD-MM-YYYY") : "--",
    },
    { key: "5", label: "Defect Liability Period (Days)", children: project?.projectDefectLiabilityPeriod ?? "N/A" },
    {
      key: "6", label: "Performance Bond Start",
      children: project?.projectPerformanceBondStartDate ? moment(project?.projectPerformanceBondStartDate)?.format("DD-MM-YYYY") : "--",
    },
    {
      key: "7", label: "Performance Bond End",
      children: project?.projectPerformanceBondEndDate ? moment(project?.projectPerformanceBondEndDate)?.format("DD-MM-YYYY") : "--",
    },
  ];

  const items3 = [
    { key: "1", label: "Total Project Cost", children: cashConverter(project?.projectCost) },
    { key: "2", label: "Revised Project Cost", children: cashConverter(project?.projectRevisedCost) },
    { key: "3", label: "Advance Payment", children: cashConverter(project?.projectAdvancedPayment) },
    {
      key: "4", label: "Advance Payment Date",
      children: project?.projectAdvancedPaymentDate ? moment(project?.projectAdvancedPaymentDate)?.format("DD-MM-YYYY") : "--",
    },
  ];

  const items4 = [
    { key: "1", label: "Volume of Water (M³)", children: project?.projectWaterVolume ?? "N/A" },
    {
      key: "2", label: "Targeted Area Under Irrigation",
      children: project?.projectAreaTarget ? `${project?.projectAreaTarget} Acre` : "N/A",
    },
    { key: "3", label: "Potential Beneficiaries", children: project?.projectPotentialBeneficiaries ?? "N/A" },
    { key: "4", label: "Livestock Potential Beneficiaries", children: project?.projectLiveStockBeneficially ?? "N/A" },
    { key: "5", label: "Remarks", children: <DescriptionPanel text={project?.projectRemarks} /> },
  ];

  return (
    <Drawer
      title={project?.projectName || "Project Details"}
      placement="right"
      onClose={() => {
        setMore(false);
        onClose();
      }}
      open={open}
      width={900}
    >
      <div className="custom-title">Project Details</div>
      <Descriptions
        column={2}
        colon={true}
        items={items1}
        labelStyle={{ width: 200 }}
      />
      <div
        className="py-[2rem] cursor-pointer text-darkBlue font-interSans text-[.875rem] font-[500] underline gap-x-[.5rem] flex items-center"
        onClick={() => setMore(!more)}
      >
        {more ? "View Less" : "View More"}
        {more ? (
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99941 4.58164C7.84941 4.58164 7.72441 4.63164 7.59941 4.73164L1.84941 10.3816C1.62441 10.6066 1.62441 10.9566 1.84941 11.1816C2.07441 11.4066 2.42441 11.4066 2.64941 11.1816L7.99941 5.95664L13.3494 11.2316C13.5744 11.4566 13.9244 11.4566 14.1494 11.2316C14.3744 11.0066 14.3744 10.6566 14.1494 10.4316L8.39941 4.78164C8.27441 4.65664 8.14941 4.58164 7.99941 4.58164Z" fill="#0092CC" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" fill="none">
            <path d="M6.99999 6.90078C6.84999 6.90078 6.72499 6.85078 6.59999 6.75078L0.849994 1.10078C0.624994 0.875781 0.624994 0.525781 0.849994 0.300781C1.07499 0.0757814 1.42499 0.0757814 1.64999 0.300781L6.99999 5.52578L12.35 0.250781C12.575 0.0257812 12.925 0.0257812 13.15 0.250781C13.375 0.475781 13.375 0.825781 13.15 1.05078L7.39999 6.70078C7.27499 6.82578 7.14999 6.90078 6.99999 6.90078Z" fill="#0092CC" />
          </svg>
        )}
      </div>
      {more && (
        <div className="w-full flex-col">
          <div className="custom-title">Timeline & Dates</div>
          <Descriptions column={2} colon={true} items={items2} labelStyle={{ width: 200 }} />
          <div className="custom-title mt-[3.25rem]">Project Cost</div>
          <Descriptions column={2} colon={true} items={items3} labelStyle={{ width: 200 }} />
          <div className="custom-title mt-[3.25rem]">Expected Deliverables</div>
          <Descriptions column={2} colon={true} items={items4} labelStyle={{ width: 200 }} />
        </div>
      )}
    </Drawer>
  );
}

export default AboutProject;
